import React from 'react';
import { MultiSelectWrapper } from './Filter.styles';

const Filter = ({ children }) => {
	return <MultiSelectWrapper>{children}</MultiSelectWrapper>;
};

export default Filter;
